module.exports = __webpack_public_path__ + "static/img/buying_four.3221281c.png";